<template>
  <asc-dialog
    :text="edit ? 'Edit Airline' : 'Add Airline'"
    :width="500"
    :show-dialog="showDialog"
    primary-button-text="Submit"
    :on-primary="onSubmitClicked"
    :primary-available="submitButtonValid"
    :on-close="onCloseDialog"
    :loading="buttonLoading"
  >
    <template v-if="showDialog">
      <asc-spinner-wrapper :loading="dialogLoading">
        <asc-airline-mgmt-form
          :data="data"
          :airlines="airlines"
          :edit="edit"
          @isValid="handleValidChanged"
          @update="handleUpdatedFields"
        ></asc-airline-mgmt-form>
      </asc-spinner-wrapper>
    </template>
  </asc-dialog>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import AscAirlineMgmtForm from './AscAirlineMgmtForm'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'

export default {
  name: 'AscAirlineMgmtDialog',

  components: {
    AscDialog,
    AscAirlineMgmtForm,
    AscSpinnerWrapper,
  },

  props: {
    onCloseDialog: {
      type: Function,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: false,
    },
    airlineData: {
      type: Object,
      default: () => {},
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    buttonLoading: {
      type: Boolean,
      default: false,
    },
    dialogLoading: {
      type: Boolean,
      default: false,
    },
    airlines: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      data: {},
      maxLength: 5,
      valid: false,
    }
  },

  computed: {
    submitButtonValid() {
      return this.edit && this.airlineData
        ? this.valid &&
            !(JSON.stringify(this.airlineData) === JSON.stringify(this.data))
        : this.valid
    },
  },

  watch: {
    airlineData: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (Object.keys(newValue).length) {
          this.data = { ...newValue }
        } else {
          this.data = {
            name: '',
            icaoCode: '',
            iataCode: '',
            aviationWeekName: '',
            cosmosURLCode: '',
            ingestionCode: '',
            isActive: false,
          }
        }
      },
    },
  },

  methods: {
    handleUpdatedFields(data) {
      this.data = { ...data }
    },
    onSubmitClicked() {
      this.$emit('submitAirline', this.data)
    },
    handleValidChanged(data) {
      this.valid = data
    },
  },
}
</script>
